import {
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    TextField,
    Box,
} from '@mui/material'
import {useI18n} from 'store/Store'
import dayjs from 'services/utils/dayjs'
import usePurchasedDances from 'logic/User/usePurchasedDances'

const PurchasedDances = ({purchasedDances}) => {
    const {i18n} = useI18n()
    const {
        searchValue,
        setSearchValue,
        filteredData,
        getDanceName,
        getChoreographers,
    } = usePurchasedDances(purchasedDances)

    if (!purchasedDances || purchasedDances.length === 0) {
        return null
    }

    return (
        <Container>
            <Box mb={2}>
                <Typography variant="h6" fontWeight={500} mb={2}>
                    {i18n.t('users.purchasedDances')} ({filteredData.length})
                </Typography>

                <TextField
                    size="small"
                    placeholder={i18n.t('users.searchPurchasedDances')}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    sx={{minWidth: 300}}
                />
            </Box>

            <TableContainer variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell width="60px">#</TableCell>
                            <TableCell>{i18n.t('users.danceName')}</TableCell>
                            <TableCell>
                                {i18n.t('users.purchaseDate')}
                            </TableCell>
                            <TableCell>
                                {i18n.t('users.choreographers')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.map(({dance, created}, index) => (
                            <TableRow key={`${dance?._id}-${index}`}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>
                                    {getDanceName(dance) || '-'}
                                </TableCell>
                                <TableCell>
                                    {created
                                        ? dayjs(created).format('DD/MM/YYYY')
                                        : '-'}
                                </TableCell>
                                <TableCell>
                                    {getChoreographers(dance) || '-'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    )
}

export default PurchasedDances

const Container = styled('div')`
    padding: 24px 12px;
    width: 100%;
`
